module.exports = __webpack_public_path__ + "static/media/abner_chen.4421aa8d.jpg";